// Duck structure from https://github.com/alexnm/re-ducks/

import reducer, { productActions, productSettings } from './reducer';
import * as actions from './actions';
import * as types from './types';

export { actions, types, productActions, productSettings };

export default reducer;
